<template>
  <div class="login">
    <div class="divider mobile-small-hide"></div>
    <div class="divider mobile-small-hide"></div>
    <b-container>
      `<b-row align-h="center">
        <b-col md="11" lg="9" xl="6">
          <h3 class="welcome-text">Selamat Datang di BNI Service Rating</h3>
          <b-alert variant="warning" class="mt-md-3" show
            ><h4>
              Website hanya bisa diakses melalui QR Code yang tersedia di outlet BNI 🙏
            </h4></b-alert
          >

          <div class="npp-block hide-block" :class="{ 'npp-block--found': hasResult }">
            <div class="d-block text-center">
              <div class="text-title text-title--sub">
                <h2>Cabang/Outlet</h2>
                <p>Silahkan pilih Cabang / Outlet</p>
              </div>
            </div>
            <div class="divider"></div>
            <div>
              <b-form-input
                autocomplete="off"
                v-model="params.q"
                placeholder="Cari Outlet"
                class="cst-input"
                v-on:keyup="getOutlet()"
                @focus="show"
                data-layout="compact"
              ></b-form-input>
              <div class="divider divider--margin-small"></div>
              <div class="divider divider--margin-small"></div>
              <div
                class="list-cb"
                :class="{ 'list-cb--found': hasResult }"
                v-if="hasResult"
              >
                <div
                  style="cursor: pointer"
                  v-for="(outlet, index) in outlets"
                  :key="index"
                  @click="setLocation(outlet.code)"
                >
                  <div class="divider divider--margin-small"></div>
                  <div class="list-cb__obj">
                    <div class="list-cb__initial">{{ outlet.outlet_status }}</div>
                    <div class="list-cb__text">
                      <h5>{{ outlet.name }}</h5>
                      <p>{{ outlet.branches_name }}, {{ outlet.region_name }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-cb" v-show="!hasResult">
                <center>{{ loadingText }}</center>
              </div>
            </div>
            <div class="divider"></div>
            <b-row> </b-row>
            <!-- </form> -->
          </div>
        </b-col> </b-row
      >`
    </b-container>
    <vue-touch-keyboard
      id="keyboard"
      :options="options"
      v-if="visible"
      :layout="layout"
      :cancel="hide"
      :accept="accept"
      :input="input"
      :change="getOutlet()"
    />
  </div>
</template>

<script>
import storage from "@/storage";
import api from "@/api/outlets";
export default {
  name: "landing",
  data() {
    return {
      visible: false,
      layout: "normal",
      input: null,
      options: {
        useKbEvents: false,
        preventClickEvent: false,
      },
      outlets: null,
      hasResult: false,
      loadingText: "",
      params: {
        q: "",
        page: 1,
      },
    };
  },
  mounted() {
    storage.clearData();
    this.getOutlet();
  },
  methods: {
    getOutlet() {
      var self = this;
      this.loadingText = "Loading...";
      api
        .get(this.params.page, this.params.q)
        .then(function (response) {
          // handle success
          if (response.data.data.length > 0) {
            self.hasResult = true;
            self.outlets = response.data.data;
          } else {
            self.hasResult = false;
            self.outlets = null;
            self.loadingText = "Outlet tidak ditemukan";
          }
          // console.log(self.outlets);
        })
        .catch(function (error) {
          console.log(error);
          self.loadingText = "Outlet tidak ditemukan";
          self.hasResult = false;
        });
    },
    setLocation(outlet_code) {
      this.$router.push(`/home/${outlet_code}`);
    },
    accept() {
      this.hide();
    },
    show(e) {
      this.input = e.target;
      this.layout = e.target.dataset.layout;

      if (!this.visible)
        if (
          !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          this.visible = true;
        }
    },
    hide() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.hide-block {
  display: none;
}

@media (max-width: 480px) {
  .welcome-text {
    font-size: 4vh;
  }
}
</style>
